<div id="footer" class="pt-4">
    <div class="container">
        <div id="logo">
            <div class="d-flex flex-row  mb-2">
                
                <div class="link   ">
                    <img src="/assets/img/logo/1.png" alt="Logo" class="img-fluid">
                </div>
                <div class="social mt-4">
                    <h2>Follow Us On:</h2>
                    <div id="social-link" class="text-center">
                       
                        <div class="col-lg-12 col-md-12 col-sm-12 text-left">
                            <a class="mr-2 social1" href="https://www.facebook.com/rpdav" target="_blank"><i class="fab fa-facebook-square"></i></a>
                            <a class="mr-2 social1" href="https://instagram.com/rpdav_school?igshid=YmMyMTA2M2Y=" target="_blank"><i class="fab fa-instagram"></i></a>
                            <a class="mr-4 social1" href="https://youtube.com/@ramprasadpublicschool9388" target="_blank"><i class="fab fa-youtube"></i></a>
                        </div>
                    </div>
                    <div class="quick-link">
                        <h2 class="mt-4">Quick Link</h2>
                        <a routerLink="/contact-us" class="text-decoration-none text-white"><i class="far fa-address-card"></i> Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
        <div id="detail">
            <!-- address -->
            <div id="address">
                <div class="logo colorWhite">
                    <mat-icon> location_on</mat-icon>
                </div>
                <div class="title colorWhite">
                    Ladwa Road Shahabad Markanda, <br> District Kurukshetra (136135), <br> Haryana
                </div>
            </div>
            <!-- Phone -->
            <div id="address">
                <div class="logo colorWhite">
                    <mat-icon> phone</mat-icon>
                </div>
                <div class="title colorWhite">
                    9896776650
                </div>
            </div>
            <!-- email -->
            <div id="address">
                <div class="logo colorWhite">
                    <mat-icon>mail</mat-icon>
                </div>
                <div class="title colorWhite">
                    rpdavsbd@gmail.com
                </div>
            </div>
        </div>
        <div id="map">
            <app-map></app-map>
        </div>
    </div>

    
    <div class="d-flex flex-row justify-content-end align-items-start">
        <div class="top mr-5">
            <button class="btn btn-light" (click)="onTop()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
              </svg> </button>
        </div>
    </div>
    <div class="copyright-area">
        <div class="container">
            <div class="row">
                <div class="col-xl-12 col-lg-12 text-center text-lg-left">
                    <div class="copyright-text">
                        <p>Designed By <a href="https://okiedokiepay.com/" target="_blank">Okie Dokie Solution LLP</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>